export default "__VITE_ASSET__130yES7o__"